import { render, staticRenderFns } from "./TableGrid.vue?vue&type=template&id=3b78f831&scoped=true"
import script from "./TableGrid.vue?vue&type=script&lang=js"
export * from "./TableGrid.vue?vue&type=script&lang=js"
import style0 from "./TableGrid.vue?vue&type=style&index=0&id=3b78f831&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b78f831",
  null
  
)

export default component.exports